<template>
  <div class="agreement_body">
    <!-- 1.营业执照 -->
    <div class="mt43">
      <div class="f13 c333"><i class="bgff8200 w3 h13 dl mr9"></i>1.营业执照</div>
      <div class="content">
        <div class="mt17 fStart">
          <div class="fStart">
            <div class="mr13 beforeStar w150 tr">营业执照：</div>
            <div class="wukongYmtCredit_blicPic " :class="[isNull('blicPic')?'red': '']">
              <imgUpload class="yyzz" :width="'128px'" :height="'130px'" @change="handleChange" :params="{ocr: {  picType:'blicPicOss'} }" :showUrl="agreementData.sanxiangData.wukongYmtCredit.blicPic" :format="['png','jpg']" :picType="'blicPicOss'">
                <template v-slot:all>
                  <img src="~@/assets/img/account/word_jpp@2x.png" alt="">
                  <p class="mt10 op">点击上传</p>
                </template>
              </imgUpload>
            </div>

          </div>
        </div>

        <div class="c999 ml150 mt13">将原件复印后加盖鲜章，上传扫描件。</div>

        <div class="fStart mt22">
          <div class="fStart w33b" v-if="agreementData.baseDate">
            <div class="mr13 beforeStar w150 tr">企业名称：</div>
            <a-input class="be9e9e9 w144 h23 f12 br4 pl7 wukongYmtCredit_enterpriseName" :class="[isNull('compName')?'red': '']" placeholder="请输入企业名称" v-model="agreementData.sanxiangData.wukongYmtCredit.compName" />
          </div>

          <div class="fStart w33b">
            <div class="mr13 beforeStar w150 tr">社会统一信用代码：</div>
            <a-input readOnly type="text" class="be9e9e9 w144 h23  f12 br4 pl7 wukongYmtCredit_compIdtNo" :class="[isNull('compIdtNo')?'red': '']" placeholder="请输入社会统一信用代码" v-model="agreementData.sanxiangData.wukongYmtCredit.compIdtNo" :max-length=18 />
          </div>

          <div class="fStart w33b">
            <div class="mr13  w150 tr">中征码：</div>
            <a-input type="text" class="be9e9e9 w144 h23 f12 br4 pl7 wukongYmtCredit_loadCardNo" placeholder="请填写中征码" data-link="sanxiangData.wukongYmtCredit.loadCardNo" v-model="agreementData.sanxiangData.wukongYmtCredit.loanCardNo" :max-length=18 />
          </div>

        </div>

        <div class="fStart mt22">

          <!-- <div class="fStart w33b">
            <div class="mr13  w150 tr">注册地址所属省/市：</div>
            <div class="pr">
              <a-input type="text" class="be9e9e9 w144 h23 f12 br4 pl7 maturityTandem maturityCity wukongYmtCredit_city" placeholder="请选择" v-model="agreementData.sanxiangData.wukongYmtCredit.address" />
            </div>
          </div> -->
          <div class="fStart w33b">
            <div class="mr13 beforeStar w150 tr">职工人数：</div>
            <a-input type="text" class="be9e9e9 w144 h23 f12 br4 pl7 wukongYmtCredit_employeeNum" :class="[isNull('employeeNum')?'red': '']" placeholder="请填写职工人数" v-model="agreementData.sanxiangData.wukongYmtCredit.employeeNum" />
          </div>

          <div class=" w33b ">
            <div class="fStart aic">
              <div class="mr13 beforeStar w150 tr">资产总额：</div>
              <a-input type="text" v-double-only class="be9e9e9 w144 h23 f12 br4 pl7 mr6 wukongYmtCredit_totalAssets moneyType" :class="[isNull('totalAssets')?'red': '']" placeholder="请填写资产总额" v-model="agreementData.sanxiangData.wukongYmtCredit.totalAssets" />元
            </div>
            <p class="w100b"><span class="c4772FF dl ml170  ">{{digitUppercase(agreementData.sanxiangData.wukongYmtCredit.totalAssets)}}</span></p>
          </div>

          <div class=" w33b ">
            <div class="fStart aic">
              <div class="mr13 beforeStar w150 tr">净资产：</div>
              <a-input type="text" v-double-only class="be9e9e9 w144 h23 f12 br4 pl7 mr6 wukongYmtCredit_netAst moneyType" :class="[isNull('netAst')?'red': '']" placeholder="请填写净资产" v-model="agreementData.sanxiangData.wukongYmtCredit.netAst" />元
            </div>
            <p class="w100b"><span class="c4772FF dl ml170  ">{{digitUppercase(agreementData.sanxiangData.wukongYmtCredit.netAst)}}</span></p>
          </div>
        </div>

        <div class="fStart mt10 aifs">



          <div class=" w33b ">
            <div class="fStart aic">
              <div class="mr13 beforeStar w150 tr">销售额：</div>
              <a-input type="text" v-double-only class="be9e9e9 w144 h23 f12 br4 pl7 mr6 wukongYmtCredit_sellSum moneyType" :class="[isNull('sellSum')?'red': '']" placeholder="请填写销售额" v-model="agreementData.sanxiangData.wukongYmtCredit.sellSum" />元
            </div>
            <p class="w100b"><span class="c4772FF dl ml170  ">{{digitUppercase(agreementData.sanxiangData.wukongYmtCredit.sellSum)}}</span></p>
          </div>
          <div class=" w33b ">
            <div class="fStart aic">
              <div class="mr13 beforeStar w150 tr">年营业额：</div>
              <a-input type="text" v-double-only class="be9e9e9 w144 h23 f12 br4 pl7 mr6 wukongYmtCredit_yearIncome moneyType" :class="[isNull('yearIncome')?'red': '']" placeholder="请填写年营业额" v-model="agreementData.sanxiangData.wukongYmtCredit.yearIncome" />元
            </div>
            <p class="w100b"><span class="c4772FF dl ml170  ">{{digitUppercase(agreementData.sanxiangData.wukongYmtCredit.yearIncome)}}</span></p>
          </div>

          <div class="fStart w33b aic">
            <div class="mr13 beforeStar w150 tr">邮箱地址：</div>
            <a-input type="text" class="be9e9e9 w144 h23 f12 br4 pl7 mr6 wukongYmtCredit_email moneyType" :class="[isNull('email')?'red': '']" placeholder="请填写邮箱地址" v-model="agreementData.sanxiangData.wukongYmtCredit.email" />
          </div>
        </div>

        <!-- <div class="fStart mt22">
          <div class="fStart w33b aic">
            <div class="mr13 beforeStar w150 tr">邮箱地址：</div>
            <a-input type="text" v-double-only class="be9e9e9 w144 h23 f12 br4 pl7 mr6 wukongYmtCredit_netAst moneyType" placeholder="请填写净资产" v-model="agreementData.sanxiangData.wukongYmtCredit.email" :max-length=18 />
          </div>
        </div> -->
      </div>
    </div>

    <!-- 2身份证 -->
    <div class="mt43">
      <div class="f13 c333"><i class="bgff8200 w3 h13 dl mr9"></i>2.法人身份证</div>
      <div class="content">
        <div class="mt17 fStart">
          <div class="fStart w50b">
            <div class="mr13 beforeStar w150 tr">人像面：</div>
            <div class="wukongYmtCredit_lepPicA" :class="[isNull('lepPicA')?'red': '']">
              <imgUpload class="yyzz" :width="'128px'" :height="'130px'" @change="handleChange" :params="{ocr: {  picType:'lepPicAOss'} }" :showUrl="agreementData.sanxiangData.wukongYmtCredit.lepPicA" :format="['png','jpg']" :picType="'blicPicOss'">
                <template v-slot:all>
                  <img src="~@/assets/img/account/word_jpp@2x.png" alt="">
                  <p class="mt10 op">点击上传</p>
                </template>
              </imgUpload>
            </div>
          </div>
          <div class="fStart w50b">
            <div class="mr13 beforeStar w150 tr">国徽面：</div>
            <div class="wukongYmtCredit_lepPicB" :class="[isNull('lepPicB')?'red': '']">
              <imgUpload class="yyzz" :width="'128px'" :height="'130px'" @change="handleChange" :params="{ocr: {  picType:'lepPicBOss'} }" :showUrl="agreementData.sanxiangData.wukongYmtCredit.lepPicB" :format="['png','jpg']" :picType="'blicPicOss'">
                <template v-slot:all>
                  <img src="~@/assets/img/account/word_jpp@2x.png" alt="">
                  <p class="mt10 op">点击上传</p>
                </template>
              </imgUpload>
            </div>
          </div>
        </div>


        <div class="fStart mt22 ">

          <div class="fStart w33b aic" v-if="agreementData.baseDate">
            <div class="mr13 beforeStar w150 tr">法人姓名：</div>
            <a-input type="text" class="be9e9e9 w144 h23 f12 br4 pl7 wukongYmtCredit_artifName" :class="[isNull('artifName')?'red': '']" placeholder="法人姓名" v-model="agreementData.sanxiangData.wukongYmtCredit.artifName" />
          </div>
          <div class="fStart w33b aic" v-if="agreementData.baseDate">
            <div class="mr13 beforeStar w150 tr">证件类型:</div>
            <a-select class=" w144 h23 f12 br4 wukongYmtCredit_artifCertIdType" :class="[isNull('artifCertIdType')?'red': '']" size="small" placeholder="请填选择证件类型" default-value="lucy" style="width: 120px" v-model="agreementData.sanxiangData.wukongYmtCredit.artifCertIdType">
              <a-select-option value="0">
                身份证
              </a-select-option>
            </a-select>
          </div>
          <div class="fStart w33b aic">
            <div class="mr13 beforeStar w150 tr">身份证号码：</div>
            <a-input type="text" class="be9e9e9 w144 h23 f12 br4 pl7 wukongYmtCredit_artifCertId" :class="[isNull('artifCertId')?'red': '']" placeholder="请输入身份证号码" v-model="agreementData.sanxiangData.wukongYmtCredit.artifCertId" :max-length=18 />
          </div>


        </div>
        <div class="fStart mt22">

          <div class="fStart w33b aic">
            <div class="mr13 beforeStar w150 tr">法人电话：</div>
            <a-input type="text" class="be9e9e9 w144 h23 f12 br4 pl7 wukongYmtCredit_artifTelephone" :class="[isNull('artifTelephone')?'red': '']" placeholder="请填写法人电话" :max-length=11 v-model="agreementData.sanxiangData.wukongYmtCredit.artifTelephone" />
          </div>

          <div class="fStart w33b aic">
            <div class="mr13 beforeStar w150 tr">法人证件登记日期：</div>
            <!-- <DatePicker type="date" placeholder="请选择证件登记日期" class="be9e9e9 w144 h23 f12 br4  maturityDate noLine dateParentNotArray wukongYmtCredit_idtStartDate1" size="small" v-model="agreementData.sanxiangData.wukongYmtCredit.artifIdtStartDate" /> -->
            <a-date-picker class=" w144  noLine  wukongYmtCredit_artifIdtStartDate" @change="onCheckedDate('artifIdtStartDate')" :class="[isNull('artifIdtStartDate')?'red': '']" size="small" placeholder="请选择登记日期" v-model="agreementData.sanxiangData.wukongYmtCredit.artifIdtStartDate">
              <a-button type="" size="small" slot="renderExtraFooter" @click="agreementData.sanxiangData.wukongYmtCredit.artifIdtStartDate='99991231'">长期</a-button>
            </a-date-picker>
          </div>

          <div class="fStart w33b aic">
            <div class="mr13 beforeStar w150 tr">法人证件到期日：</div>
            <!-- <a-input type="text" class="be9e9e9 w144 h23 f12 br4 pl7 maturityDateLong noLine dateParentNotArray wukongYmtCredit_idtEndDate1" placeholder="请选择证件到期日期" v-model="agreementData.sanxiangData.wukongYmtCredit.artifIdtEndDate=='99991231'?'长期':agreementData.sanxiangData.wukongYmtCredit.artifIdtEndDate" /> -->

            <a-date-picker class=" w144  noLine  wukongYmtCredit_artifIdtEndDate" @change="onCheckedDate('artifIdtEndDate')" :class="[isNull('artifIdtEndDate')?'red': '']" size="small" placeholder="请选择到期日" v-model="agreementData.sanxiangData.wukongYmtCredit.artifIdtEndDate">
              <a-button type="" size="small" slot="renderExtraFooter" @click="agreementData.sanxiangData.wukongYmtCredit.artifIdtEndDate='99991231'">长期</a-button>
            </a-date-picker>
          </div>
        </div>

        <!-- <div class="fStart mt22">
          <div class="fStart w33b">
            <div class="mr13 beforeStar w150 tr">法人证件登记日期：</div>
            <DatePicker type="date" placeholder="请选择证件登记日期" class="be9e9e9 w144 h23 f12 br4  maturityDate noLine dateParentNotArray wukongYmtCredit_idtStartDate1" size="small" v-model="agreementData.sanxiangData.wukongYmtCredit.artifIdtStartDate" />
          </div>

          <div class="fStart w33b">
            <div class="mr13 beforeStar w150 tr">法人证件到期日：</div>
            <a-input type="text" class="be9e9e9 w144 h23 f12 br4 pl7 maturityDateLong noLine dateParentNotArray wukongYmtCredit_idtEndDate1" placeholder="请选择证件到期日期" v-model="agreementData.sanxiangData.wukongYmtCredit.artifIdtEndDate=='99991231'?'长期':agreementData.sanxiangData.wukongYmtCredit.artifIdtEndDate" />
          </div>
        </div> -->

      </div>
    </div>

    <!-- 3.经办人信息 -->
    <div class="mt43">
      <div class="f13 c333"><i class="bgff8200 w3 h13 dl mr9"></i>3.经办人信息</div>
      <div class="content">
        <div class="mt17 fStart">
          <div class="fStart w50b">
            <div class="mr13 beforeStar w150 tr">人像面：</div>
            <div class="wukongYmtCredit_aupPicA" :class="[isNull('aupPicA')?'red': '']">
              <imgUpload class="yyzz" :width="'128px'" :height="'130px'" @change="handleChange" :params="{ocr: {  picType:'aupPicAOss'} }" :showUrl="agreementData.sanxiangData.wukongYmtCredit.aupPicA" :format="['png','jpg']">
                <template v-slot:all>
                  <img src="~@/assets/img/account/word_jpp@2x.png" alt="">
                  <p class="mt10 op">点击上传</p>
                </template>
              </imgUpload>
            </div>
          </div>
          <div class="fStart w50b">
            <div class="mr13 beforeStar w150 tr">国徽面：</div>
            <div class="wukongYmtCredit_aupPicB" :class="[isNull('aupPicB')?'red': '']">
              <imgUpload class="yyzz" :width="'128px'" :height="'130px'" @change="handleChange" :params="{ocr: {  picType:'aupPicBOss'} }" :showUrl="agreementData.sanxiangData.wukongYmtCredit.aupPicB" :format="['png','jpg']">
                <template v-slot:all>
                  <img src="~@/assets/img/account/word_jpp@2x.png" alt="">
                  <p class="mt10 op">点击上传</p>
                </template>
              </imgUpload>
            </div>
          </div>
        </div>

        <div class="fStart mt22">
          <div class="fStart w33b aic">
            <div class="mr13 beforeStar w150 tr">经办人姓名：</div>
            <a-input type="text" class="be9e9e9 w144 h23 f12 br4 pl7 wukongYmtCredit_owner" :class="[isNull('owner')?'red': '']" placeholder="请填写经办人姓名" v-model="agreementData.sanxiangData.wukongYmtCredit.owner" />
          </div>


          <div class="fStart w33b aic">
            <div class="mr13 beforeStar w150 tr">证件类型：</div>
            <a-select class=" w144 h23 f12 br4 wukongYmtCredit_telephone" :class="[isNull('owerCertType')?'red': '']" size="small" placeholder="请填选择证件类型" default-value="0" style="width: 120px" v-model="agreementData.sanxiangData.wukongYmtCredit.owerCertType">
              <a-select-option value="0">
                身份证
              </a-select-option>
            </a-select>
          </div>

          <div class="fStart w33b aic">
            <div class="mr13 beforeStar w150 tr">经办人证件号码：</div>
            <a-input type="text" class="be9e9e9 w144 h23 f12 br4 pl7 wukongYmtCredit_owerCertId" :class="[isNull('owerCertId')?'red': '']" placeholder="请填写经办人证件号码" v-model="agreementData.sanxiangData.wukongYmtCredit.owerCertId" :max-length=18 />
          </div>
        </div>

        <div class="fStart mt22">
          <div class="fStart w33b aic">
            <div class="mr13 beforeStar w150 tr">经办人电话：</div>
            <a-input type="text" class="be9e9e9 w144 h23 f12 br4 pl7 wukongYmtCredit_telephone" :class="[isNull('ownerTelephone')?'red': '']" placeholder="请填写经办人电话" :max-length=11 v-model="agreementData.sanxiangData.wukongYmtCredit.ownerTelephone" />
          </div>

          <!-- <div class="fStart w33b">
            <div class="mr13  w150 tr">证件签发机关：</div>
            <div class="pr">
              <a-input data-param1="sanxiangData.wukongYmtCredit.userProvience" data-param2="sanxiangData.wukongYmtCredit.userCity" type="text" class="be9e9e9 w144 h23 f12 br4 pl7 maturityTandem maturityCity wukongYmtCredit_userArea" placeholder="请选择" v-model="agreementData.sanxiangData.wukongYmtCredit.ownerCnldRegCity" />
            </div>
          </div> -->

          <!-- <div class="fStart w33b">
            <div class="mr13  w150 tr">经办人地址：</div>
            <div class="pr">
              <a-input data-param1="sanxiangData.wukongYmtCredit.userProvience" data-param2="sanxiangData.wukongYmtCredit.userCity" type="text" class="be9e9e9 w144 h23 f12 br4 pl7 maturityTandem maturityCity wukongYmtCredit_userArea" placeholder="请选择" v-model="agreementData.sanxiangData.wukongYmtCredit.owerAddress" />
            </div>
          </div> -->

          <div class="fStart w33b aic">
            <div class="mr13 beforeStar w150 tr">经办人证件登记日期：</div>
            <!-- <a-input type="text" class="be9e9e9 w144 h23 f12 br4 pl7 maturityDate noLine dateParentNotArray wukongYmtCredit_idtStartDate" placeholder="请选择证件登记日期" v-model="agreementData.sanxiangData.wukongYmtCredit.ownerIdtStartDate" /> -->
            <a-date-picker class=" w144  noLine  wukongYmtCredit_ownerIdtStartDate" @change="onCheckedDate('ownerIdtStartDate')" :class="[isNull('ownerIdtStartDate')?'red': '']" size="small" placeholder="请选择登记日期" v-model="agreementData.sanxiangData.wukongYmtCredit.ownerIdtStartDate">
              <a-button type="" size="small" slot="renderExtraFooter" @click="agreementData.sanxiangData.wukongYmtCredit.ownerIdtStartDate='99991231'">长期</a-button>
            </a-date-picker>
          </div>

          <div class="fStart w33b aic">
            <div class="mr13 beforeStar w150 tr">经办人证件到期日：</div>
            <!-- <a-input type="text" class="be9e9e9 w144 h23 f12 br4 pl7 maturityDateLong noLine dateParentNotArray wukongYmtCredit_idtEndDate" placeholder="请选择证件到期日期" v-model="agreementData.sanxiangData.wukongYmtCredit.ownerIdtEndDate=='99991231'?'长期':agreementData.sanxiangData.wukongYmtCredit.idtEndDate" /> -->
            <a-date-picker class=" w144  noLine  wukongYmtCredit_ownerIdtEndDate" @change="onCheckedDate('ownerIdtEndDate')" :class="[isNull('ownerIdtEndDate')?'red': '']" size="small" placeholder="请选择到期日" v-model="agreementData.sanxiangData.wukongYmtCredit.ownerIdtEndDate">
              <a-button type="" size="small" slot="renderExtraFooter" @click="agreementData.sanxiangData.wukongYmtCredit.ownerIdtEndDate='99991231'">长期</a-button>
            </a-date-picker>
          </div>
        </div>

        <!-- <div class="fStart mt22">

          <div class="fStart w33b">
            <div class="mr13 beforeStar w150 tr">经办人证件登记日期：</div>
            <a-input type="text" class="be9e9e9 w144 h23 f12 br4 pl7 maturityDate noLine dateParentNotArray wukongYmtCredit_idtStartDate" placeholder="请选择证件登记日期" v-model="agreementData.sanxiangData.wukongYmtCredit.ownerIdtStartDate" />
          </div>

          <div class="fStart w33b">
            <div class="mr13 beforeStar w150 tr">经办人证件到期日：</div>
            <a-input type="text" class="be9e9e9 w144 h23 f12 br4 pl7 maturityDateLong noLine dateParentNotArray wukongYmtCredit_idtEndDate" placeholder="请选择证件到期日期" v-model="agreementData.sanxiangData.wukongYmtCredit.ownerIdtEndDate=='99991231'?'长期':agreementData.sanxiangData.wukongYmtCredit.idtEndDate" />
          </div>

        </div> -->
      </div>
    </div>

    <!-- 4.受益人信息 -->
    <div class="mt43">
      <div class="f13 c333">
        <i class="bgff8200 w3 h13 dl mr9"></i><span>4.受益人信息</span>
        <span class="c4772FF fr cp add_stockholder_sanxiang" @click="addBeneficiary">+增加</span>
      </div>
      <div class="content">
        <a-table :columns="benefitArray.columns" :data-source="agreementData.sanxiangData.wukongYmtCredit.benefitArray" :pagination="false" class="w100b be9e9e9 bsb mt22">
          <div slot="benefitName" slot-scope="text, record,index" class="beforeStar">
            <a-input class="be9e9e9 w84" :class="[isNull('benefitName','benefitArray',index)?'red': '']" placeholder="请填写受益人姓名" size="small" v-model="agreementData.sanxiangData.wukongYmtCredit.benefitArray[index].benefitName"></a-input>
          </div>

          <div slot="benefitCertIdType" slot-scope="text, record,index" class="beforeStar">
            <a-select class=" w130 h23 f12 br4 " :class="[isNull('benefitCertIdType','benefitArray',index)?'red': '']" size="small" placeholder="请填选择证件类型" default-value="0" style="width: 120px" v-model="agreementData.sanxiangData.wukongYmtCredit.benefitArray[index].benefitCertIdType">
              <a-select-option value="0">
                身份证
              </a-select-option>
            </a-select>
          </div>

          <div slot="benefitCertId" slot-scope="text, record,index" class="beforeStar">
            <a-input class="be9e9e9 w130" :class="[isNull('benefitCertId','benefitArray',index)?'red': '']" size="small" placeholder="请填证件号码" v-model="agreementData.sanxiangData.wukongYmtCredit.benefitArray[index].benefitCertId" :max-length=18></a-input>
          </div>

          <div slot="benefitAddress" slot-scope="text, record,index">
            <a-cascader :options="options" placeholder="请选择地址" size="small" @change="onChange" v-model="agreementData.sanxiangData.wukongYmtCredit.benefitArray[index].benefitAddress" />
          </div>

          <div slot="benefitIdtEndDate" slot-scope="text, record,index" class="beforeStar">
            <a-date-picker class=" w130 " :class="[isNull('benefitIdtEndDate','benefitArray',index)?'red': '']" @change="onCheckedDate('benefitIdtEndDate','benefitArray',index)" size="small" placeholder="请选择到期日" v-model="agreementData.sanxiangData.wukongYmtCredit.benefitArray[index].benefitIdtEndDate">
              <a-button type="" size="small" slot="renderExtraFooter" @click="agreementData.sanxiangData.wukongYmtCredit.benefitArray[index].benefitIdtEndDate='99991231'">长期</a-button>
            </a-date-picker>
          </div>

          <div slot="benefitIdtBeginDate" slot-scope="text, record,index" class="beforeStar">
            <a-date-picker class=" w130 " :class="[isNull('benefitIdtBeginDate','benefitArray',index)?'red': '']" @change="onCheckedDate('benefitIdtBeginDate','benefitArray',index)" size="small" placeholder="请选择证件登记日期" v-model="agreementData.sanxiangData.wukongYmtCredit.benefitArray[index].benefitIdtBeginDate">
              <a-button type="" size="small" slot="renderExtraFooter" @click="agreementData.sanxiangData.wukongYmtCredit.benefitArray[index].benefitIdtBeginDate = '99991231'">长期</a-button>
            </a-date-picker>
          </div>

          <span slot="action" slot-scope="text,record,index"><i class="icon remove cp del_stockholder_sanxiang" @click="deleteBeneficiary(index)"></i></span>
        </a-table>
      </div>
    </div>

    <!-- 5.股东信息 -->
    <div class="mt43">
      <div class="f13 c333">
        <i class="bgff8200 w3 h13 dl mr9"></i><span>5.股东信息</span>
        <span class="c4772FF fr cp add_stockholder_sanxiang" @click="addStockHolder">+增加</span>
      </div>
      <div class="content">
        <a-table :columns="stockHolderArray.columns" :data-source="agreementData.sanxiangData.wukongYmtCredit.stockHolderArray" :pagination="false" class="w100b be9e9e9 bsb mt22">

          <div slot="custName" slot-scope="text, record,index" class="beforeStar">
            <a-input class="be9e9e9 w84 " :class="[isNull('custName','stockHolderArray',index)?'red': '']" placeholder="请输入姓名" size="small" v-model="agreementData.sanxiangData.wukongYmtCredit.stockHolderArray[index].custName"></a-input>
          </div>

          <div slot="certIdtType" slot-scope="text, record,index" class="beforeStar">
            <a-select class=" w130 h23 f12 br4 " :class="[isNull('certIdtType','stockHolderArray',index)?'red': '']" size="small" placeholder="请填选择证件类型" default-value="lucy" style="width: 120px" v-model="agreementData.sanxiangData.wukongYmtCredit.stockHolderArray[index].certIdtType">
              <a-select-option value="0">
                身份证
              </a-select-option>
            </a-select>
          </div>

          <div slot="certId" slot-scope="text, record,index" class="beforeStar">
            <a-input class="be9e9e9 w130" :class="[isNull('certId','stockHolderArray',index)?'red': '']" size="small" placeholder="请填写证件号码" v-model="agreementData.sanxiangData.wukongYmtCredit.stockHolderArray[index].certId" :max-length=18></a-input>
          </div>


          <div slot="regDate" slot-scope="text, record,index" class="beforeStar">
            <a-date-picker class=" w130 " :class="[isNull('regDate','stockHolderArray',index)?'red': '']" size="small" @change="onCheckedDate('regDate','stockHolderArray',index)" placeholder="请选择证件登记日期" v-model="agreementData.sanxiangData.wukongYmtCredit.stockHolderArray[index].regDate">
              <template slot="renderExtraFooter">
                <a-button size="small" @click="agreementData.sanxiangData.wukongYmtCredit.stockHolderArray[index].regDate = '99991231'">长期</a-button>
              </template>
            </a-date-picker>
          </div>

          <div slot="idExpiry" slot-scope="text, record,index" class="beforeStar">
            <a-date-picker class=" w130 " :class="[isNull('idExpiry','stockHolderArray',index)?'red': '']" @change="onCheckedDate('idExpiry','stockHolderArray',index)" size="small" placeholder="请选择到期日" v-model="agreementData.sanxiangData.wukongYmtCredit.stockHolderArray[index].idExpiry">
              <a-button type="" size="small" slot="renderExtraFooter" @click="agreementData.sanxiangData.wukongYmtCredit.stockHolderArray[index].idExpiry= '99991231'">长期</a-button>
            </a-date-picker>
          </div>

          <span slot="action" slot-scope="text,record,index"><i class="icon remove cp del_stockholder_sanxiang" @click="deleteStockHolder(index)"></i></span>
        </a-table>

      </div>
    </div>


    <!-- 6.文件资料 -->
    <div class="mt43">
      <div class="f13 c333"><i class="bgff8200 w3 h13 dl mr9"></i>6.文件资料</div>
      <div class="content">

        <div class="fStart mt22 ">
          <div class="fStart w33b aic">
            <div class="mr13  w150 tr">上一年度资产负债表文件：</div>
            <div class="dCC w100 cp h100" :class="[agreementData.sanxiangData.wukongYmtCredit.balanceSheetFile?'': 'noFile']" @click="imgUploadClick('balanceSheetFile')">
              <img src="~@/assets/img/account/file.png" v-if="agreementData.sanxiangData.wukongYmtCredit.balanceSheetFile" class="mb5" alt="">
              <span class="f20 fb" v-else>+</span>

              <imgUpload class=" wukongYmtCredit_benefitName dn" ref="balanceSheetFile" @change="filChange" :params="{ isShowImg: false}" :showUrl="agreementData.sanxiangData.wukongYmtCredit.balanceSheetFile" :format="[]" :fieldName="'balanceSheetFile'">
              </imgUpload>

              <span v-if="this.fileInfo.FileName.balanceSheetFile" class="w100b otw tc f12">{{this.fileInfo.FileName.balanceSheetFile}}</span>
              <span class="mt10 cp"><span> {{agreementData.sanxiangData.wukongYmtCredit.balanceSheetFile?'重新上传': '点击上传'}}</span> <span v-if="agreementData.sanxiangData.wukongYmtCredit.balanceSheetFile" class="ml10" @click="overView(agreementData.sanxiangData.wukongYmtCredit.balanceSheetFile)">预览</span></span>
            </div>
          </div>

          <div class="fStart w33b aic">
            <div class="mr13  w150 tr">上一年度利润表文件：</div>
            <div class="dCC w100 cp h100" :class="[agreementData.sanxiangData.wukongYmtCredit.incomeStatementFile?'': 'noFile']" @click="imgUploadClick('incomeStatementFile')">
              <img src="~@/assets/img/account/file.png" v-if="agreementData.sanxiangData.wukongYmtCredit.incomeStatementFile" class="mb5" alt="">
              <span class="f20 fb" v-else>+</span>

              <imgUpload class=" wukongYmtCredit_benefitName dn" ref="incomeStatementFile" @change="filChange" :params="{ isShowImg: false}" :showUrl="agreementData.sanxiangData.wukongYmtCredit.incomeStatementFile" :format="[]" :fieldName="'incomeStatementFile'">
              </imgUpload>

              <span v-if="this.fileInfo.FileName.incomeStatementFile" class="w100b otw tc f12">{{this.fileInfo.FileName.incomeStatementFile}}</span>
              <span class="mt10 cp">{{agreementData.sanxiangData.wukongYmtCredit.incomeStatementFile?'重新上传': '点击上传'}} <span v-if="agreementData.sanxiangData.wukongYmtCredit.incomeStatementFile" class="ml10" @click="overView(agreementData.sanxiangData.wukongYmtCredit.incomeStatementFile)">预览</span></span>
            </div>
          </div>

          <div class="fStart w33b aic">
            <div class="mr13  w150 tr">上一年度现金流量表文件：</div>
            <div class="dCC w100 cp h100" :class="[agreementData.sanxiangData.wukongYmtCredit.cashFlowStatementFile?'': 'noFile']" @click="imgUploadClick('cashFlowStatementFile')">
              <img src="~@/assets/img/account/file.png" v-if="agreementData.sanxiangData.wukongYmtCredit.cashFlowStatementFile" class="mb5" alt="">
              <span class="f20 fb" v-else>+</span>

              <imgUpload class=" wukongYmtCredit_benefitName dn" ref="cashFlowStatementFile" @change="filChange" :params="{ isShowImg: false}" :showUrl="agreementData.sanxiangData.wukongYmtCredit.cashFlowStatementFile" :format="[]" :fieldName="'cashFlowStatementFile'">
              </imgUpload>

              <span v-if="this.fileInfo.FileName.cashFlowStatementFile" class="w100b otw tc f12">{{this.fileInfo.FileName.cashFlowStatementFile}}</span>
              <span class="mt10 cp" @click="imgUploadClick('cashFlowStatementFile')">{{agreementData.sanxiangData.wukongYmtCredit.cashFlowStatementFile?'重新上传': '点击上传'}} <span v-if="agreementData.sanxiangData.wukongYmtCredit.cashFlowStatementFile" class="ml10" @click="overView(agreementData.sanxiangData.wukongYmtCredit.cashFlowStatementFile)">预览</span></span>
            </div>
          </div>
        </div>

        <!-- <div class="fStart mt22">
          <div class="fStart w33b aic">
            <div class="mr13  w150 tr">分公司注册授权书：</div>
            <div class="dCC w100 cp h100" :class="[fileInfo.FileName.subsidiaryRegisterAuthorizationFile?'': 'noFile']" @click="imgUploadClick('subsidiaryRegisterAuthorizationFile')">
              <img src="~@/assets/img/account/file.png" v-if="fileInfo.FileName.subsidiaryRegisterAuthorizationFile" class="mb5" alt="">
              <span class="f20 fb" v-else>+</span>

              <imgUpload class=" wukongYmtCredit_benefitName dn" ref="subsidiaryRegisterAuthorizationFile" @change="filChange" :params="{ isShowImg: false}" :showUrl="agreementData.sanxiangData.wukongYmtCredit.subsidiaryRegisterAuthorizationFile" :format="[]" :fieldName="'subsidiaryRegisterAuthorizationFile'">
              </imgUpload>

              <span class="mt10 cp" @click="imgUploadClick('subsidiaryRegisterAuthorizationFile')">{{fileInfo.FileName.subsidiaryRegisterAuthorizationFile?'重新上传': '点击上传'}}</span>
            </div>
          </div>

          <div class="fStart w33b aic">
            <div class="mr13  w150 tr">开户许可证：</div>
            <div class="dCC w100 cp h100" :class="[fileInfo.FileName.openAcctLicenceFile?'': 'noFile']" @click="imgUploadClick('openAcctLicenceFile')">
              <img src="~@/assets/img/account/file.png" v-if="fileInfo.FileName.openAcctLicenceFile" class="mb5" alt="">
              <span class="f20 fb" v-else>+</span>

              <imgUpload class=" wukongYmtCredit_benefitName dn" ref="openAcctLicenceFile" @change="filChange" :params="{ isShowImg: false}" :showUrl="agreementData.sanxiangData.wukongYmtCredit.openAcctLicenceFile" :format="[]" :fieldName="'openAcctLicenceFile'">
              </imgUpload>

              <span class="mt10 cp" @click="imgUploadClick('openAcctLicenceFile')">{{fileInfo.FileName.openAcctLicenceFile?'重新上传': '点击上传'}}</span>
            </div>
          </div>
        </div> -->

      </div>
    </div>
    <!-- 7.开户 -->
    <div class="mt43">
      <div class="f13 c333"><i class="bgff8200 w3 h13 dl mr9"></i>7.开户信息</div>
      <div class="content">

        <div class="fStart mt22 aic">
          <div class="fStart w33b">
            <div class="mr13 beforeStar w150 tr">开户行名称：</div>
            <a-input type="text" class="be9e9e9 w144 h23 f12 br4 pl7 wukongYmtCredit_benefitName" :class="[isNull('acctBankName')?'red': '']" placeholder="请填写开户行名称" v-model="agreementData.sanxiangData.wukongYmtCredit.acctBankName" />
          </div>

          <div class="fStart w33b aic">
            <div class="mr13 beforeStar w150 tr">开户银行行号：</div>
            <input type="text" class="be9e9e9 w144 h23 f12 br4 pl7 wukongYmtCredit_benefitCertId" :class="[isNull('acctBankNo')?'red': '']" placeholder="请填写开户行行号" v-model="agreementData.sanxiangData.wukongYmtCredit.acctBankNo" :max-length=12 />
          </div>

          <div class="fStart w33b aic">
            <div class="mr13 beforeStar w150 tr">开户银行账号：</div>
            <a-input type="text" class="be9e9e9 w144 h23 f12 br4 pl7 wukongYmtCredit_benefitCertId" :class="[isNull('acctNo')?'red': '']" placeholder="请填写开户行账号" v-model="agreementData.sanxiangData.wukongYmtCredit.acctNo" :max-length=30 />
          </div>
        </div>

      </div>
    </div>

    <div class="mt43">
      <div>
        <input class="cp" type="checkbox" name="agreementCheckbox" />
        <span>我已阅读并同意相关服务信息
          <span><a :href="ossUrl('/common/protocol/ktb/sanxiang/DiscountProtocol.doc')" target="_blank" class="c4772FF ml5">《电子商业汇票贴现协议》</a></span>
        </span>
        <span>
          <span><a :href="ossUrl('/common/protocol/ktb/sanxiang/CorpAuthorization.docx')" target="_blank" rel="noopener " class="c4772FF ml5">《单位授权委托书》</a></span>
        </span>
        <span>
          <span><a :href="ossUrl('/common/protocol/ktb/sanxiang/CorpCreditAuthorization.docx')" target="_blank" class="c4772FF ml5">《企业版征信授权书》</a></span>
        </span>
        <span>
          <span><a :href="ossUrl('/common/protocol/ktb/sanxiang/CorpESignAuthorization.docx')" target="_blank" class="c4772FF ml5">《企业电子签章授权委托书》</a></span>
        </span>
      </div>
    </div>
    <div class="mt43 pb20">
      <p class="" v-if="bankSubDto.nodeMessage"><span>节点：</span> {{bankSubDto.nodeMessage}}</p>
      <!--签约成功-->
      <div v-if="bankSubDto.status === 'CREDIT_SUCCESS'">
        <div class="mt43 fJCenter pb20" v-if="bankSubDto.node === 'APPLY_CREDIT_WAIT_IDENTIFY' || bankSubDto.node === 'CHANGE_CREDIT_WAIT_IDENTIFY' || bankSubDto.node === 'CHANGE_CHANNEL_WAIT_IDENTIFY' || bankSubDto.node === 'CHANGE_AUP_WAIT_IDENTIFY'">
          <Button class="w110 btnff8200bg tc cp br4 submit" type="primary" @click="writeSXMoney">填写鉴权金额</Button>
        </div>
        <div v-else-if="(!bankSubDto.node || bankSubDto.node === 'SUCCESS'|| bankSubDto.node === 'FAIL') " class="mt43 fJCenter pb20">
          <Button class="w110 btnff8200bg tc cp br4 submit mr10" type="primary" @click="submit('changeCredit')">变更签约信息</Button>
          <!-- <Button class="w110 btnff8200bg tc cp br4 submit" type="primary" @click="submit()">变更签约渠道</Button> -->
          <Button class="w110 btnff8200bg tc cp br4 submit mr10" type="primary" @click="changeAupModal = true">变更经办人</Button>
          <Button class="w110 btnff8200bg tc cp br4 submit" type="primary" @click="applyQuotaModoal = true">申请提额</Button>
        </div>
      </div>
      <!--未签约成功-->
      <div v-else class="mt43 fJCenter pb20">
        <!--申请签约待小额鉴定-->
        <Button v-if="bankSubDto.node === 'APPLY_CREDIT_WAIT_IDENTIFY'" class="w110 btnff8200bg tc cp br4 submit" type="primary" @click="writeSXMoney">填写鉴权金额</Button>
        <Button v-if="bankSubDto.status === 'NO_CREDIT' || bankSubDto.status ===  'CREDIT_FAIL'" class="w110 btnff8200bg tc cp br4 submit" type="primary" @click="submit('applyCredit')">申请签约</Button>
      </div>

    </div>

    <!-- 变更经办人信息 -->
    <Modal v-model="changeAupModal" :footer-hide="true" width="1000" class="header-dn" id="changeAup">
      <p slot="header" class="tc cfff hl42">
        <span class="f18">变更经办人信息</span>
      </p>
      <div class="mt43">
        <div class="f13 c333"><i class="bgff8200 w3 h13 dl mr9"></i>3.经办人信息</div>
        <div class="content">
          <div class="mt17 fStart">
            <div class="fStart w50b">
              <div class="mr13 beforeStar w150 tr">人像面：</div>
              <div class="wukongYmtCredit_aupPicA" :class="[isNull('aupPicA','','', 'changeAupParams')?'red': '']">
                <imgUpload class="yyzz" :width="'128px'" :height="'130px'" @change="changeAupUpload" :params="{ocr: {  picType:'aupPicAOss'} }" :showUrl="changeAupParams.aupPicA" :format="['png','jpg']" :fieldName="'aupPicA'">
                  <template v-slot:all>
                    <img src="~@/assets/img/account/word_jpp@2x.png" alt="">
                    <p class="mt10 op">点击上传</p>
                  </template>
                </imgUpload>
              </div>
            </div>
            <div class="fStart w50b">
              <div class="mr13 beforeStar w150 tr">国徽面：</div>
              <div class="wukongYmtCredit_aupPicB" :class="[isNull('aupPicB','','', 'changeAupParams')?'red': '']">
                <imgUpload class="yyzz" :width="'128px'" :height="'130px'" @change="changeAupUpload" :params="{ocr: {  picType:'aupPicBOss'} }" :showUrl="changeAupParams.aupPicB" :format="['png','jpg']" :fieldName="'aupPicB'">
                  <template v-slot:all>
                    <img src="~@/assets/img/account/word_jpp@2x.png" alt="">
                    <p class="mt10 op">点击上传</p>
                  </template>
                </imgUpload>
              </div>
            </div>
          </div>

          <div class="fStart mt22">
            <div class="fStart w33b aic">
              <div class="mr13 beforeStar w150 tr">经办人姓名：</div>
              <a-input type="text" class="be9e9e9 w144 h23 f12 br4 pl7 wukongYmtCredit_compName" :class="[isNull('compName','','', 'changeAupParams')?'red': '']" placeholder="请填写经办人姓名" v-model="changeAupParams.compName" />
            </div>


            <div class="fStart w33b aic">
              <div class="mr13 beforeStar w150 tr">经办人证件号码：</div>
              <a-input type="text" class="be9e9e9 w144 h23 f12 br4 pl7 wukongYmtCredit_compIdtNo" :class="[isNull('compIdtNo','','', 'changeAupParams')?'red': '']" placeholder="请填写经办人证件号码" v-model="changeAupParams.compIdtNo" :max-length=18 />
            </div>

            <div class="fStart w33b">
              <div class="mr13  w150 tr">证件住址：</div>
              <div class="pr">
                <a-cascader :options="options" placeholder="请选择地址" size="small" @change="onChange" v-model="changeAupParams.compIdAdress" />
              </div>
            </div>
          </div>
        </div>

        <div class="fStart mt22">
          <div class="fStart w33b aic">
            <div class="mr13 beforeStar w150 tr">经办人电话：</div>
            <a-input type="text" class="be9e9e9 w144 h23 f12 br4 pl7 wukongYmtCredit_compTelephone" :class="[isNull('compTelephone','','', 'changeAupParams')?'red': '']" placeholder="请填写经办人电话" :max-length=11 v-model="changeAupParams.compTelephone" />
          </div>


          <div class="fStart w33b aic">
            <div class="mr13 beforeStar w150 tr">经办人证件登记日期：</div>
            <a-date-picker class=" w144  noLine  wukongYmtCredit_compIdValidity" :class="[isNull('compIdValidity','','', 'changeAupParams')?'red': '']" size="small" placeholder="请选择登记日期" v-model="changeAupParams.compIdValidity">
              <a-button type="" size="small" slot="renderExtraFooter" @click="changeAupParams.compIdValidity='99991231'">长期</a-button>
            </a-date-picker>
          </div>

          <div class="fStart w33b aic">
            <div class="mr13 beforeStar w150 tr">经办人证件到期日：</div>
            <a-date-picker class=" w144  noLine  wukongYmtCredit_compIdExpiry" :class="[isNull('compIdExpiry','','', 'changeAupParams')?'red': '']" size="small" placeholder="请选择到期日" v-model="changeAupParams.compIdExpiry">
              <a-button type="" size="small" slot="renderExtraFooter" @click="changeAupParams.compIdExpiry='99991231'">长期</a-button>
            </a-date-picker>
          </div>
        </div>

        <!-- <div class="fStart mt22">
          <div class="fStart w33b aic">
            <div class="mr13  w150 tr">分公司注册授权书：</div>
            <div class="dCC w100">
              <img src="~@/assets/img/account/file.png" class="mb5" alt="">

              <imgUpload class=" wukongYmtCredit_authorizationFile dn" ref="authorizationFile" @change="changeAupUpload" :params="{ isShowImg: false}" :showUrl="changeAupParams.authorizationFile" :format="[]" :fieldName="'authorizationFile'">
              </imgUpload>

              <span v-if="changeAupParams.authorizationFile" class="w100b tc otw">{{changeAupParams.authorizationFile}}</span>
              <span class="mt10 cp" @click="imgUploadClick('authorizationFile')">{{changeAupParams.authorizationFile?'重新上传': '点击上传'}}</span>
            </div>
          </div>
        </div> -->
        <p class="tc w100b mt30">
          <a :href="ossUrl('/common/protocol/ktb/sanxiang/ChangeAupAuthorization.docx')" target="_blank" class="c4772FF ml10">《湖南三湘银行易秒贴业务联系人变更授权委托书》</a>
        </p>
        <div class="mt10 fJCenter pb20">
          <Button class="w110 btnff8200bg tc cp br4 submit" type="primary" @click="changeAupSubmit">确认</Button>
        </div>
      </div>
    </Modal>
    <!-- 提额申请 -->
    <Modal v-model="applyQuotaModoal" :footer-hide="true" width="1000" class="header-dn" id="applyQuota">
      <p slot="header" class="tc cfff hl42">
        <span class="f18">提额申请</span>
      </p>
      <div class="mt43">
        <div class="fStart mt22">
          <div class="fStart  aic">
            <div class="mr13 beforeStar w150 tr">年营业收入：</div>
            <a-input type="text" :class="[isNull('balanceSheetFile','','', 'applyQuotaParams')?'red': '']" class="be9e9e9 w144 h23 f12 br4 pl7 wukongYmtCredit_yearIncome" placeholder="请填写年营业额" v-model="applyQuotaParams.yearIncome" :max-length=18 /> 元
          </div>
        </div>

        <div class="fStart mt22">
          <div class="fStart w33b aic">
            <div class="mr13 beforeStar w150 tr">上一年度资产负债表（公章）：</div>
            <div class="dCC w100 cp h100" :class="[isNull('balanceSheetFile','','', 'applyQuotaParams')?'red': '', applyQuotaParams.balanceSheetFile?'': 'noFile']" @click="imgUploadClick('applyQuotaParamsBalanceSheetFile')">
              <img src="~@/assets/img/account/file.png" v-if="applyQuotaParams.balanceSheetFile" class="mb5" alt="">
              <span class="f20 fb" v-else>+</span>

              <imgUpload class="dn" ref="applyQuotaParamsBalanceSheetFile" @change="applyQuotaUpload" :params="{ isShowImg: false}" :showUrl="applyQuotaParams.balanceSheetFile" :format="[]" :fieldName="'balanceSheetFile'">
              </imgUpload>
              <span v-if="this.fileInfo.applyQuotaParams.balanceSheetFile" class="w100b otw tc f12">{{this.fileInfo.applyQuotaParams.balanceSheetFile}}</span>
              <span class="mt10 cp">{{applyQuotaParams.balanceSheetFile?'重新上传': '点击上传'}} <span class="ml10" v-if="applyQuotaParams.balanceSheetFile" @click="overView(applyQuotaParams.balanceSheetFile)">预览</span></span>
            </div>
          </div>
          <div class="fStart w33b aic">
            <div class="mr13 beforeStar w150 tr">上一年度利润表（公章）：</div>
            <div class="dCC w100 cp h100" :class="[isNull('incomeStatementFile','','', 'applyQuotaParams')?'red': '', applyQuotaParams.incomeStatementFile?'': 'noFile']" @click="imgUploadClick('applyQuotaParamsIncomeStatementFile')">
              <img src="~@/assets/img/account/file.png" v-if="applyQuotaParams.incomeStatementFile" class="mb5" alt="">
              <span class="f20 fb" v-else>+</span>

              <imgUpload class="dn" ref="applyQuotaParamsIncomeStatementFile" @change="applyQuotaUpload" :params="{ isShowImg: false}" :showUrl="changeAupParams.incomeStatementFile" :format="[]" :fieldName="'incomeStatementFile'">
              </imgUpload>
              <span v-if="this.fileInfo.applyQuotaParams.incomeStatementFile" class="w100b otw tc f12">{{this.fileInfo.applyQuotaParams.incomeStatementFile}}</span>
              <span class="mt10 cp" @click="imgUploadClick('balanceSheetFilebalanceSheetFile')">{{applyQuotaParams.incomeStatementFile?'重新上传': '点击上传'}} <span v-if="changeAupParams.incomeStatementFile" class="ml10" @click="overView(changeAupParams.incomeStatementFile)">预览</span></span>
            </div>
          </div>
          <div class="fStart w33b aic">
            <div class="mr13 beforeStar w150 tr">上一年度现金流量表（公章）：</div>
            <div class="dCC w100 cp h100" :class="[isNull('cashFlowStatementFile','','', 'applyQuotaParams')?'red': '', applyQuotaParams.cashFlowStatementFile?'': 'noFile']" @click="imgUploadClick('applyQuotaParamsCashFlowStatementFile')">
              <img src="~@/assets/img/account/file.png" v-if="applyQuotaParams.cashFlowStatementFile" class="mb5" alt="">
              <span class="f20 fb" v-else>+</span>

              <imgUpload class="dn" ref="applyQuotaParamsCashFlowStatementFile" @change="applyQuotaUpload" :params="{ isShowImg: false}" :showUrl="applyQuotaParams.cashFlowStatementFile" :format="[]" :fieldName="'cashFlowStatementFile'">
              </imgUpload>
              <span v-if="this.fileInfo.applyQuotaParams.cashFlowStatementFile" class="w100b otw tc f12">{{this.fileInfo.applyQuotaParams.cashFlowStatementFile}}</span>
              <span class="mt10 cp" @click="imgUploadClick('balanceSheetFilebalanceSheetFile')">{{applyQuotaParams.cashFlowStatementFile?'重新上传': '点击上传'}} <span v-if="changeAupParams.cashFlowStatementFile" class="ml10" @click="overView(changeAupParams.cashFlowStatementFile)">预览</span></span>
            </div>
          </div>
        </div>
        <div class="mt43 fJCenter pb20">
          <Button class="w110 btnff8200bg tc cp br4 submit" type="primary" @click="applyQuotaSubmit">确认</Button>
        </div>
      </div>
    </Modal>

    <!--填写三湘的小额鉴权金额-->
    <Modal v-model="SXModelMoney" width="770" :footer-hide="true" :mask-closable="false">
      <!--重写顶部-->
      <p slot="header" class="tc cfff hl35">
        <span class="f18">填写小额鉴权金额</span>
      </p>
      <template v-if="SXStatus=='success'">
        <div class="df aic jcc fDC" style="height: 400px">
          <Icon type="ios-checkmark-circle" class="f102 dp-c-success mb16" />
          <div class="f24 c333 fb mb10">金额提交成功!</div>
          <div class="c666 f14 mb35">签约进入审核阶段，请耐心等待...</div>
          <Button class="f14 h34" type="primary" @click="SXConfirm()">确定</Button>
        </div>
      </template>
      <template v-else>
        <div style="width: 560px;" class="m0a">
          <p class="f16 c999 mt80 mb14">请在此账户网银上查询一笔小于1元的鉴权金额：</p>
          <table cellspacing="0" cellpadding="10" class="w100b bccc">
            <tr>
              <td class="brccc c666 f16 bbccc tc l44" style="width: 106px;">账户名称</td>
              <td class="f14 c333 bbccc pl15">{{agreementData.sanxiangData.wukongYmtCredit.compName}}</td>
            </tr>
            <tr>
              <td class="brccc c666 f16 bbccc tc l44">账号</td>
              <td class="f14 c333 bbccc pl15">{{agreementData.sanxiangData.wukongYmtCredit.acctNo}}</td>
            </tr>
            <tr>
              <td class="brccc c666 f16 tc l44">开户行</td>
              <td class="f14 c333 pl15">{{agreementData.sanxiangData.wukongYmtCredit.acctBankName}}</td>
            </tr>
          </table>
          <div class="mt40 mb45 tc">
            <label>
              <span>小额鉴权金额：</span>
              <Input class="mr8" v-model="SXmoney" placeholder="0.00" style="width: 266px;" v-double-only />
            </label>
          </div>
          <div class="tc">
            <Button class="f14 w80 h32" type="primary" @click="sumitSXAmount">提交</Button>
          </div>
        </div>
      </template>
    </Modal>
  </div>

</template>

<script>
import "@/assets/js/foundation-datepicker.js";
import "@/assets/js/maturityTandem.js";
import imgUpload from '../module/imgUpload.vue'
import 'ant-design-vue/dist/antd.css'
let _this = '';

export default {
  name: "agreementMenu",
  components: {
    imgUpload
  },
  props: ['bankId'],
  data () {
    return {
      agreementData: {
        // 三湘协议请求参数--自渠道
        sanxiangData: {
          id: '',
          bankId: '', // 签约银行信息主键id
          wukongYmtCreditId: '', //签约资料ID
          wukongYmtCredit: {
            id: '', //ID
            compName: '', //客户名称
            compIdtNo: '', //统一社会信用代码
            loanCardNo: '', //中征码
            netAst: '', //净资产
            stockHolderArray: [
              {
                custName: '', //客户名称
                certIdtType: '', //证件类型
                // 0-身份证
                // 1-统一社会信用代码
                certId: '', //证件编号
                regDate: '', //证件登记日期(yyyyMMdd)
                idExpiry: '', //证件到期日(yyyyMMdd)
                // 证件到期日必须晚于证件登记日期，长期送 99991231
              }
            ], //股东信息
            employeeNum: '', //职工人数
            sellSum: '', //销售额（元）
            yearIncome: '', //年营业收入
            totalAssets: '', //资产总额（元）
            address: '', //营业执照住所
            artifName: '', //法人名称
            artifCertIdType: '', //法人证件类型
            // 0-身份证
            artifCertId: '', //法人证件编号
            artifTelephone: '', //法人电话
            artifCnldRegCity: '', //法人证件签发机关
            artifCertAddress: '', //法人证件住址
            artifIdtStartDate: '', //法人证件登记日期
            artifIdtEndDate: '', //法人证件到期日
            owner: '', //授权经办人姓名
            ownerTelephone: '', //授权经办人电话
            owerCertType: '', //授权经办人证件类型
            // 0-身份证
            owerCertId: '', //授权经办人证件号码
            ownerCnldRegCity: '', //授权经办人证件签发机关
            owerAddress: '', //授权经办人证件住址
            ownerIdtStartDate: '', //授权经办人证件登记日期
            ownerIdtEndDate: '', //授权经办人证件到期日
            benefitArray: [
              {
                benefitName: '', //受益人姓名
                benefitCertId: '', //受益人证件号码
                benefitCertIdType: '', //受益人证件类型
                // 0-身份证
                benefitIdtBeginDate: '', //受益人证件起始日
                benefitIdtEndDate: '', //受益人证件到期日
                // benefitAddress: '' //受益人地址
              }
            ], //受益人信息
            acctBankName: '', //开户行名称
            acctNo: '', //公司银行账号
            acctBankNo: '',
            blicPic: '', //营业执照
            lepPicA: '', //法人身份证人像面
            lepPicB: '', //法人身份证国徽面
            aupPicA: '', //经办人身份证人像面
            aupPicB: '', //经办人身份国徽面
            balanceSheetFile: '', //上一年度资产负债表文件
            incomeStatementFile: '', //上一年度利润表文件
            cashFlowStatementFile: '', //上一年度现金流量表文件
            subsidiaryRegisterAuthorizationFile: '', //分公司注册授权书
            openAcctLicenceFile: '' //开户许可证
          },

        },
        // 协议参数名
        paramName: "sanxiangData", //

        // 下拉选择参数列表
        baseDate: {
          // 国标行业分类(兴业提供的编码)
          industryType: [],
          // 机构类型
          orgType: [],
          // 企业类型
          corpType: [],
          // 证件类型
          certType: [],
          // 地区信息（兴业提供的编码）
          areaCode: [],
        },

        // 当前签约银行的行业分类
        cuIndustry: ''
      },
      bankSubDto: {
        status: '',
        node: '',
        nodeDesc: '',
        nodeMessage: ''
      },
      FileName: {
        balanceSheetFile: '', //上一年度资产负债表文件
        incomeStatementFile: '', //上一年度利润表文件
        cashFlowStatementFile: '', //上一年度现金流量表文件
        subsidiaryRegisterAuthorizationFile: '', //分公司注册授权书
        openAcctLicenceFile: '' //开户许可证
      },
      params: {
        ocr: false,
        loadding: false,// 上传中 Loading 效果
        isShowImg: true,// 图片预览
        isReUpload: false, // 是否展示重新上传按钮
        ocr: { // ocr 识别
          picType: 'blicPicOss'// 上传图片类型 用于OCR识别
        },
        required: true
      },
      benefitArray: {
        columns: [
          {
            title: '姓名',
            dataIndex: 'benefitName',
            scopedSlots: { customRender: 'benefitName' }
          },
          {
            title: '证件类型',
            dataIndex: 'benefitCertIdType',
            scopedSlots: { customRender: 'benefitCertIdType' }
          },
          {
            title: '证件号码',
            dataIndex: 'benefitCertId',
            scopedSlots: { customRender: 'benefitCertId' }
          },
          {
            title: '证件登记日期',
            dataIndex: 'benefitIdtBeginDate',
            scopedSlots: { customRender: 'benefitIdtBeginDate' }
          },
          {
            title: '证件到期日',
            dataIndex: 'benefitIdtEndDate',
            scopedSlots: { customRender: 'benefitIdtEndDate' }
          },
          // {
          //   title: '地址',
          //   dataIndex: 'benefitAddress',
          //   scopedSlots: { customRender: 'benefitAddress' }
          // },
          {
            title: '',
            dataIndex: '',
            scopedSlots: { customRender: 'action' }
          }
        ],
        data: []
      },
      options: [],
      stockHolderArray: {
        columns: [
          {
            title: '姓名',
            dataIndex: 'custName',
            scopedSlots: { customRender: 'custName' }
          },
          {
            title: '证件类型',
            dataIndex: 'certIdtType',
            scopedSlots: { customRender: 'certIdtType' }
          },
          {
            title: '证件号码',
            dataIndex: 'certId',
            scopedSlots: { customRender: 'certId' }
          },
          {
            title: '证件登记日期',
            dataIndex: 'regDate',
            scopedSlots: { customRender: 'regDate' }
          },
          {
            title: '证件到期日',
            dataIndex: 'idExpiry',
            scopedSlots: { customRender: 'idExpiry' }
          },
          {
            title: '',
            dataIndex: '',
            scopedSlots: { customRender: 'action' }
          }
        ],
        data: []
      },
      checkedFlag: false, // 校验标识
      changeAupParamsFlag: false, // 变更经办人校验标识
      applyQuotaParamsFlag: false, // 申请提额校验标识

      // 是否存储当前数据
      saveData: true,
      uploadNum: 0,
      subtype: '', // 二级协议类型
      none_ststus: false, // 判断是否存在没有填写的数据

      changeAupModal: false, // 三湘变更经办人
      changeAupParams: {
        compName: "", //经办人姓名
        compIdtNo: "", //经办人身份证号
        compTelephone: "", //经办人手机号
        compIdValidity: "", //经办人证件起始日
        compIdExpiry: "", //经办人证件到期日，长期上送99991231
        compIdAdress: [], //经办人地址
        aupPicA: "", //经办人证件人像面
        aupPicB: "", //经办人证件国徽面
        authorizationFile: process.env.OSSParam.endpoint + '/common/protocol/ktb/sanxiang/ChangeAupAuthorization.docx' //渠道变更业务办理授权书
      },
      applyQuotaModoal: false,
      applyQuotaParams: {
        yearIncome: "",
        balanceSheetFile: "",
        incomeStatementFile: "",
        cashFlowStatementFile: ''
      },
      fileInfo: {
        applyQuotaParams: {
          balanceSheetFile: "",
          incomeStatementFile: "",
          cashFlowStatementFile: ''
        },
        FileName: {
          balanceSheetFile: '', //上一年度资产负债表文件
          incomeStatementFile: '', //上一年度利润表文件
          cashFlowStatementFile: '', //上一年度现金流量表文件
          subsidiaryRegisterAuthorizationFile: '', //分公司注册授权书
          openAcctLicenceFile: '' //开户许可证
        },
      },
      SXModelMoney: false, // 小额鉴定
      SXStatus: false,
      SXmoney: '',
      SXAcctInfo: '',

    }
  },
  filters: {
    formatterMobile (value) {
      if (value && value.length == 11) {
        let mobile = value.slice(0, 3) + '-' + value.slice(3, 7) + '-' + value.slice(7);
        return mobile
      }
      return '';
    }
  },
  watch: {
    changeAupModal: {
      handler: () => {
        _this.changeAupParamsFlag = false
        _this.changeAupParams = {
          compName: "", //经办人姓名
          compIdtNo: "", //经办人身份证号
          compTelephone: "", //经办人手机号
          compIdValidity: "", //经办人证件起始日
          compIdExpiry: "", //经办人证件到期日，长期上送99991231
          compIdAdress: [], //经办人地址
          aupPicA: "", //经办人证件人像面
          aupPicB: "", //经办人证件国徽面
          authorizationFile: process.env.OSSParam.endpoint + '/common/protocol/ktb/sanxiang/ChangeAupAuthorization.docx' //渠道变更业务办理授权书
        }
      }
    },
    applyQuotaModoal: {
      handler: () => {
        _this.applyQuotaParamsFlag = false
        _this.applyQuotaParams = {
          yearIncome: "",
          balanceSheetFile: "",
          incomeStatementFile: "",
          cashFlowStatementFile: ''
        }
      }
    },
  },
  mounted () {

    console.log($(".relevanceCompany"), 'mounted');
  },
  created () {
    _this = this;
    console.log('this.$route.params.id', this.$route, '*******', _this.bankId, this.$route.query);
    // 页面跳转
    if (_this.bankId) {
      // this.initData();
      this.syncSignBankStatus(_this.bankId)
    } else {
      // this.$router.push('/SilverTicketManage');
    }

    // if (this.$route.params.id) {
    //   this.agreementData.sanxiangData.bankId = this.$route.params.id
    //   this.syncSignBankStatus(this.$route.params.id)
    // }

    // 监听页面刷新、跳转
    window.addEventListener("beforeunload", hashChangeFire);
    window.onbeforeunload = hashChangeFire;
    window.onunload = hashChangeFire;
    function hashChangeFire () {
      _this.saveData ? sessionStorage.setItem('signBank' + _this.agreementData.sanxiangData.bankId, JSON.stringify(_this.agreementData)) : '';        // 存储数据
    }
  },
  beforeDestroy () {
    if (this.agreementData.paramName) {
      this.saveData ? localStorage.setItem('signBank' + this.agreementData.sanxiangData.bankId, JSON.stringify(this.agreementData)) : '';        // 存储数据
    }
  },


  methods: {
    // 初始化数据
    initData (bankId) {
      _this.addLoading();
      // 请求初始化数据参数
      this.sendGet({
        method: 'get',
        url: '/web/discount-acct/bank/credit',
        data: {
          bank_id: bankId,
        },
      }, (result) => {
        this.checkedFlag = false // 校验标识
        let data = result.data.data
        this.agreementData.baseDate = Object.assign({}, this.agreementData.baseDate, data.creditParam)
        this.agreementData.sanxiangData.wukongYmtCredit = Object.assign({}, this.agreementData.sanxiangData.wukongYmtCredit, data.bankSubDto.wukongYmtCredit)
        this.bankSubDto.status = data.status
        this.bankSubDto.node = data.bankSubDto.node ? data.bankSubDto.node : ''
        this.bankSubDto.nodeDesc = data.bankSubDto.nodeDesc ? data.bankSubDto.nodeDesc : ''
        this.bankSubDto.nodeMessage = data.bankSubDto.nodeMessage ? data.bankSubDto.nodeMessage : ''
        this.agreementData.sanxiangData.bankId = data.bankSubDto.bankId
        this.agreementData.sanxiangData.id = data.bankSubDto.id
        this.agreementData.sanxiangData.wukongYmtCreditId = data.bankSubDto.wukongYmtCredit.id
        // console.log(data.bankSubDto.wukongYmtCredit.stockHolderAwukongYmtCreditrray && data.bankSubDto.wukongYmtCredit.stockHolderArray.length > 0);
        console.log(data.bankSubDto.wukongYmtCredit.stockHolderArray);

        _this.agreementData.sanxiangData.wukongYmtCredit.stockHolderArray = (data.bankSubDto.wukongYmtCredit.stockHolderArray && data.bankSubDto.wukongYmtCredit.stockHolderArray.length) > 0 ? data.bankSubDto.wukongYmtCredit.stockHolderArray : [{
          custName: '', //客户名称
          certIdtType: '', //证件类型
          // 0-身份证
          // 1-统一社会信用代码
          certId: '', //证件编号
          regDate: '', //证件登记日期(yyyyMMdd)
          idExpiry: '', //证件到期日(yyyyMMdd)
          // 证件到期日必须晚于证件登记日期，长期送 99991231
        }]
        _this.agreementData.sanxiangData.wukongYmtCredit.benefitArray = data.bankSubDto.wukongYmtCredit.benefitArray.length > 0 ? data.bankSubDto.wukongYmtCredit.benefitArray : [{
          benefitName: '', //受益人姓名
          benefitCertId: '', //受益人证件号码
          benefitCertIdType: '', //受益人证件类型
          // 0-身份证
          benefitIdtBeginDate: '', //受益人证件起始日
          benefitIdtEndDate: '', //受益人证件到期日
          // benefitAddress: '' //受益人地址
        }]

        this.SXModelMoney = false
        this.SXStatus = false
        this.SXmoney = ''
        this.SXAcctInfo = ''
        // 初始化地址级联选择
        _this.agreementData.baseDate.areaCode.map(item => {
          _this.options.push(this.setValue(item))
        })

      }, error => {
        // 失败
      })
    },
    syncSignBankStatus (bankId) {
      // 同步贴现企业签约银行状态
      this.sendGet({
        url: '/web/discount-acct/bank/sync',
        data: {
          bank_id: bankId
        },
      }, (result) => {
        // console.log("ack回调", result);
        _this.initData(bankId);
      }, (result) => {
        // console.log("其他回调", result);
      })

    },
    onCheckedDate (type, keyName, index) {
      if (keyName) {
        const date = (new Date(this.compatibilityIEDate(this.agreementData.sanxiangData.wukongYmtCredit[keyName][index][`${type}`]))).pattern("yyyyMMdd")
        this.agreementData.sanxiangData.wukongYmtCredit[keyName][index][`${type}`] = date
      } else {
        const date = (new Date(this.compatibilityIEDate(this.agreementData.sanxiangData.wukongYmtCredit[`${type}`]))).pattern("yyyyMMdd")
        this.agreementData.sanxiangData.wukongYmtCredit[`${type}`] = date

      }
    },
    setValue (item) {
      let obj = {}
      obj.label = item.name
      obj.value = item.name
      if (item.subList) {
        obj.children = []
        item.subList.map(i => {
          obj.children.push(this.setValue(i))
        })
      }
      return obj
    },
    // 提交数据
    submit (type) {
      this.checkedFlag = true // 校验标识
      this.$nextTick(() => {
        if (this.checkData(type)) {
          _this.$Message.warning("请先完善页面相关信息");
          return false;
        }

        if ($("input[type=checkbox][name=agreementCheckbox]").length > 0) {
          if (!$("input[type=checkbox][name=agreementCheckbox]")[0].checked) {
            this.$Message.warning("请先同意相关协议");
            return false;
          }
        }

        _this.addLoading();
        let requestData = {};
        requestData.bankSubJsonObj = this.agreementData.sanxiangData;


        switch (type) {
          case 'applyCredit':
            _this.submitData(requestData, '/web/discount-acct/apply-credit/', 'put');
            break;
          case 'changeCredit':
            _this.submitData(requestData, '/web/discount-acct-bank-sanxiang/changeCredit/', 'post');
            break;
        }
      })

    },
    changeAupSubmit () {
      this.changeAupParamsFlag = true
      this.$nextTick(() => {
        if (this.checkData('changeAup')) {
          _this.$Message.warning("请先完善页面相关信息");
          return false;
        }
        let requestData = {};
        requestData = {
          record: _this.changeAupParams
        }
        requestData.record.compIdAdress = ''

        _this.submitData(requestData, '/web/discount-acct-bank-sanxiang/changeAup/', 'post');
        this.changeAupModal = false
      })
      // this.checkData('changeAup')

      console.log(this.checkData('applyQuota'));

    },
    applyQuotaSubmit () {
      this.applyQuotaParamsFlag = true
      this.$nextTick(() => {
        if (this.checkData('applyQuota')) {
          _this.$Message.warning("请先完善页面相关信息");
          return false;
        }
        let requestData = {};
        requestData = {
          record: _this.applyQuotaParams
        }

        _this.submitData(requestData, '/web/discount-acct-bank-sanxiang/applyQuota/', 'post');
        this.applyQuotaModoal = false
      })
    },
    checkData (element) {
      let el
      let first_none_value_node
      if (element !== 'applyCredit' || element !== 'changeCredit') {
        first_none_value_node = document.querySelector('.red')
      } else {
        el = document.getElementById(`${element}`)
        first_none_value_node = el ? el.querySelector('.red') : document.querySelector('.red')
      }
      if (first_none_value_node) {
        first_none_value_node.scrollIntoView({
          behavior: "smooth",  // 平滑过渡
          block: 'center', //居中
        })
        return true

      } else {
        return false
      }
    },

    isNull (e, r, index, type) {
      if (type) {
        return this[`${type}` + 'Flag'] && !this[type][e]
      } else {
        if (r) {
          return this.checkedFlag && !this.agreementData.sanxiangData.wukongYmtCredit[r][index][e]
        } else {
          let res = this.agreementData.sanxiangData.wukongYmtCredit[e]
          return this.checkedFlag && !res
        }
      }


    },
    ossUrl (url) {
      return process.env.OSSParam.endpoint + url
    },
    overView (url) {
      window.open(url)
    },
    // 提交数据
    submitData (requestData, url, methodType) {
      if (_this.uploadNum > 0) {
        _this.removeLoading();
        this.$Message.error('请等待文件上传成功之后再提交');
        return false;
      }
      if (!url) {
        url = '/web/discount-acct/bank/';
      }
      // 提交
      this.sendOther({
        url: url + _this.agreementData.sanxiangData.bankId,
        data: requestData,
        method: methodType ? methodType : 'put'
      }, (result) => {
        localStorage.removeItem('signBank' + this.agreementData.sanxiangData.bankId);
        this.saveData = false;
        this.$Message.success(result.data.message);
        this.initData(_this.bankId);
        _this.syncSignBankStatus(_this.bankId)

      }, (result) => {
        // // console.log("其他回调", result);
      })
    },
    // 确定
    SXConfirm () {
      _this.SXModelMoney = false;
      _this.accountList = '';
      this.syncSignBankStatus(this.bankId);
    },
    // 设置金额不能为大写的字符
    // noAmountWords (arrayList) {
    //   arrayList.forEach((str) => {
    //     let strList = str.split('.');
    //     listValue(_this.agreementData.sanxiangData, 0, strList);
    //   })

    //   function listValue (param, i, strList) {
    //     if (param.hasOwnProperty(strList[i])) {
    //       if (strList.length == i + 1) {
    //         console.log(param[strList[i]])
    //         param[strList[i]] = (param[strList[i]] && param[strList[i]].match(/^\d*(\.?\d{0,2})/g)[0]) || '';
    //         return param[strList[i]];
    //       } else {
    //         return listValue(param[strList[i]], ++i, strList);
    //       }
    //     }
    //   }
    // },
    // 金额输入框聚焦事件
    onfocus (type) {
      _this.$set(_this.agreementData.sanxiangData.wukongYmtCredit, `${type}` + 'Str', null)
    },
    onblur (item) {
      if (this.agreementData.sanxiangData.wukongYmtCredit[item]) {
        let nub = _this.agreementData.sanxiangData.wukongYmtCredit[item]
        _this.$set(_this.agreementData.sanxiangData.wukongYmtCredit, `${item}` + 'Str', this.formatMoney(nub, 2, ''))
        _this.agreementData.sanxiangData.wukongYmtCredit[item] = null
        _this.agreementData.sanxiangData.wukongYmtCredit[item] = nub

      } else {
        _this.$set(this.agreementData.sanxiangData.wukongYmtCredit, `${item}` + 'Str', null)
      }
    },
    // 根据国标行业分类code获取行业名称
    findNameByIndustryType: function (list, code) {
      if (!code) return '';
      for (var i in list) {
        if (list[i].code == code) {
          return list[i].name;
        } else {
          if (list[i].subList != null) {
            var res = this.findNameByIndustryType(list[i].subList, code)
            if (res) { return res }
          }
        }
      }
      return '';
    },
    // 根据地区code获取地区名称
    findNameByAreaCode: function (list, code) {
      if (!code) return '';
      for (var i in list) {
        if (list[i].code == code) {
          return list[i].name;
        } else {
          if (list[i].subList != null) {
            var res = this.findNameByAreaCode(list[i].subList, code);
            if (res) { return res }
          }
        }
      }
    },
    initEleAdd: function () {
      // 输入框为日期格式 --- 斜线分割
      $('.agreement_body .maturityDate.noLine').fdatepicker({ format: 'yyyyMMdd' });
      $('.agreement_body .maturityDateLong.noLine').fdatepicker({ format: 'yyyyMMdd' }, "长期");

      // 非数组中的处理
      $('.agreement_body').off("change", ".dateParentNotArray").on("change", ".dateParentNotArray", function () {
        let array = String($(this).attr("data-link")).split('.');
        // // console.log(array);

        let cuDate = _this.getDateString($(this).val());

        if (array.length == 2) {
          _this.agreementData[array[0]][array[1]] = cuDate;
        } else if (array.length == 3) {
          _this.agreementData[array[0]][array[1]][array[2]] = cuDate;
        }

      });

      // 数组中的处理
      $('.agreement_body').off("change", ".dateParentArray").on("change", ".dateParentArray", function () {
        let array = String($(this).attr("data-link")).split('.');
        let index = $(this).attr("data-index");
        // console.log("change dateParentArray", array, index, array[0])
        // // console.log(array);

        let cuDate = _this.getDateString($(this).val());

        if (array.length == 2) {
          _this.agreementData[array[0]][index][array[1]] = cuDate;
        } else if (array.length == 3) {
          _this.agreementData[array[0]][array[1]][index][array[2]] = cuDate;
        } else if (array.length == 4) {
          _this.agreementData[array[0]][array[1]][array[2]][index][array[3]] = cuDate;
        } else if (array.length == 5) {
          _this.agreementData[array[0]][array[1]][array[2]][array[3]][array[4]] = cuDate;
        }
      });
      // 非数组中的处理
      $('.agreement_body').off("change", ".maturityTandem:not('.maturityTandemArray')").on("change", ".maturityTandem:not('.maturityTandemArray')", function () {
        // console.log("change");
        let array = String($(this).attr("data-link")).split('.');
        let param1 = $(this).attr("data-param1");
        param1 && _this.setArrayVal(`agreementData.${param1}`.split('.'), $(this).attr("code1"))
        let param2 = $(this).attr("data-param2");
        param2 && _this.setArrayVal(`agreementData.${param2}`.split('.'), $(this).attr("code2"))
        // // console.log(array);
        if (array.length == 2) {
          _this.agreementData[array[0]][array[1]] = $(this).val();
          _this.agreementData[array[0]][array[1].slice(0, -4)] = $(this).attr("code");
        } else if (array.length == 3) {
          _this.agreementData[array[0]][array[1]][array[2]] = $(this).val();
          _this.agreementData[array[0]][array[1]][array[2].slice(0, -4)] = $(this).attr("code");
        }
      });
    },

    getDateString (val, fieldName, index) {
      this.$nextTick(() => {
        _this.agreementData.sanxiangData.wukongYmtCredit[val][index][fieldName] = '99991231'

      })
    },


    // 签约上传图片函数
    handleChange (ossData, ocrData, type) {
      console.log('***************', ossData);
      let that = this
      if (ossData) {

        switch (type) {
          case 'blicPicOss':
            console.log(type);
            this.agreementData.sanxiangData.wukongYmtCredit.blicPic = ossData.url
            if (ocrData) {
              that.agreementData.sanxiangData.wukongYmtCredit.compName = ocrData.data.name; // 识别的公司名称
              that.agreementData.sanxiangData.wukongYmtCredit.address = ocrData.data.address; // 地址
              // that.agreementData.sanxiangData.wukongYmtCredit.idExpiry = ocrData.data.valid_period; // 证件到期日 日期需转
              // that.agreementData.sanxiangData.wukongYmtCredit.mostBusiness = ocrData.data.business; // mostBusiness 经营范围
              // that.agreementData.sanxiangData.wukongYmtCredit.registerCapital = ocrData.data.capital; // mostBusiness 注册资本 汉字需转
              // that.agreementData.sanxiangData.wukongYmtCredit.setupDate = ocrData.data.valid_period; // mostBusiness 成立日期
            }

            break;
          case 'lepPicAOss':
            that.agreementData.sanxiangData.wukongYmtCredit.lepPicA = ossData.url
            if (ocrData) {
              that.agreementData.sanxiangData.wukongYmtCredit.artifName = ocrData.data.name; // 识别的公司名称
              that.agreementData.sanxiangData.wukongYmtCredit.artifCertId = ocrData.data.num; // 识别的公司名称
              // that.agreementData.sanxiangData.wukongYmtCredit.artifCertAddress = ocrData.data.address; // 识别的公司名称
            }

            break;
          case 'lepPicBOss':
            that.agreementData.sanxiangData.wukongYmtCredit.lepPicB = ossData.url
            if (ocrData) {
              that.agreementData.sanxiangData.wukongYmtCredit.artifIdtStartDate = ocrData.data.start_date; // 识别的公司名称
              that.agreementData.sanxiangData.wukongYmtCredit.artifIdtEndDate = ocrData.data.end_date; // 识别的公司名称
            }

            break;
          case 'aupPicAOss':
            that.agreementData.sanxiangData.wukongYmtCredit.aupPicA = ossData.url
            if (ocrData) {
              that.agreementData.sanxiangData.wukongYmtCredit.owner = ocrData.data.name; // 识别的公司名称
              that.agreementData.sanxiangData.wukongYmtCredit.owerCertId = ocrData.data.num; // 识别的公司名称
            }

            break;
          case 'aupPicBOss':
            that.agreementData.sanxiangData.wukongYmtCredit.aupPicB = ossData.url
            if (ocrData) {
              that.agreementData.sanxiangData.wukongYmtCredit.ownerIdtStartDate = ocrData.data.start_date; // 识别的公司名称
              that.agreementData.sanxiangData.wukongYmtCredit.ownerIdtEndDate = ocrData.data.end_date; // 识别的公司名称
            }

            break;

        }
      }
    },

    imgUploadClick (e, type, index) {
      this.$refs[e].reUpload()
    },

    filChange (name, url, fieldName) {
      console.log(name, url, fieldName);
      // if (url) {
      //   this.agreementData.sanxiangData.wukongYmtCredit[fieldName] = url
      //   this.fileInfo.FileName[fieldName] = name
      // }
      if (Object.prototype.toString.call(name) === '[object Object]') {
        this.agreementData.sanxiangData.wukongYmtCredit[url] = name.url
        this.fileInfo.FileName[url] = fieldName
      } else {
        this.agreementData.sanxiangData.wukongYmtCredit[fieldName] = url
        this.fileInfo.FileName[fieldName] = name
      }
    },
    changeAupUpload (ossData, ocrData, type, fieldName) {
      console.log(ossData, ocrData, type, fieldName);
      if (fieldName) {
        if (type == 'aupPicAOss') {
          this.changeAupParams.aupPicA = ossData.url
          this.changeAupParams.compIdtNo = ocrData.data.num
          this.changeAupParams.compName = ocrData.data.name
        } else {
          this.changeAupParams.aupPicB = ossData.url
          this.changeAupParams.compIdValidity = ocrData.data.start_date
          this.changeAupParams.compIdExpiry = ocrData.data.end_date
        }
      } else {

      }
    },
    applyQuotaUpload (name, url, fieldName) {
      console.log(name, url, fieldName);
      this.fileInfo.applyQuotaParams[fieldName] = name
      this.applyQuotaParams[fieldName] = url

    },

    // 增加受益人
    addBeneficiary () {
      if (this.agreementData.sanxiangData.wukongYmtCredit.benefitArray && this.agreementData.sanxiangData.wukongYmtCredit.benefitArray.length == 3) {
        this.$Message.error("最终受益人信息最多可填写三个");
        return false;
      }
      this.agreementData.sanxiangData.wukongYmtCredit.benefitArray.push({
        benefitName: '', //受益人姓名
        benefitCertId: '', //受益人证件号码
        benefitCertIdType: '', //受益人证件类型
        // 0-身份证
        benefitIdtBeginDate: '', //受益人证件起始日
        benefitIdtEndDate: '', //受益人证件到期日
        // benefitAddress: [''] //受益人地址
      })
    },
    // 删除受益人
    deleteBeneficiary (index) {
      if (this.agreementData.sanxiangData.wukongYmtCredit.benefitArray.length > 1) {
        this.agreementData.sanxiangData.wukongYmtCredit.benefitArray.splice(index, 1)
      }
    },

    // 增加股东信息
    addStockHolder () {
      this.agreementData.sanxiangData.wukongYmtCredit.stockHolderArray.push({
        custName: '', //客户名称
        certIdtType: '', //证件类型
        // 0-身份证
        // 1-统一社会信用代码
        certId: '', //证件编号
        regDate: '', //证件登记日期(yyyyMMdd)
        idExpiry: '', //证件到期日(yyyyMMdd)
      })
    },
    // 删除股东信息
    deleteStockHolder (index) {
      console.log(index);
      if (this.agreementData.sanxiangData.wukongYmtCredit.stockHolderArray.length > 1) {
        this.agreementData.sanxiangData.wukongYmtCredit.stockHolderArray.splice(index, 1)
      }
    },
    onChange () { },
    SANXIANGChangeAup (account, bank,) {
      console.log('SANXIANGChangeAup*****', account, bank)
      this.sendGet({
        method: 'get',
        url: '/web/discount-acct/bank/credit',
        data: {
          bank_id: bank.id,
        },
      }, (result) => {
        this.SXchangeAupModal = true
        console.log(result);
      }, error => {
        // 失败
      })
    },

    writeSXMoney () {
      this.SXModelMoney = true;
    },
    sumitSXAmount () {
      console.log(this.SXAcctInfo, this.SXmoney)
      if (!_this.SXmoney) {
        _this.$Message.error("请填写鉴权金额");
        return false;
      }

      // 更改鉴权金额的接口
      this.sendPost({
        url: '/web/discount-acct-bank-sanxiang/confirmIdent/' + _this.bankId,
        data: {
          identAmount: _this.SXmoney
        },
      }, (result) => {
        this.SXStatus = 'success'; // 鉴权金额提交成功
        _this.syncSignBankStatus(_this.bankId)
      }, (result) => {
        // console.log("其他回调", result);
      })
    },
  },

}
</script>

<style scoped>
@import '../../../static/css/foundation-datepicker.less';
@import '../../../static/css/main.less';
.yyzz {
  width: 128px !important;
  height: 130px !important;
  background: url(~@/assets/img/account/word_jpp@2x.png) no-repeat center center;
  border: none;
}
.sfz {
  width: 128px;
  height: 80px;
}
.borderLine {
  border: 1px solid #ccc;
  border-radius: 4px;
}
.noFile {
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 100px;
  height: 100px;
}
.ivu_wh100 .ivu-spin-main,
.ivu_wh100 .ivu-spin-text {
  width: 100%;
  height: 100%;
}
/* 公共样式 */
.beforeStar::before {
  content: '*';
  margin-right: 4px;
  color: #d0021b;
}
.l124 {
  line-height: 124px;
}

input::-webkit-input-placeholder {
  color: #ccc;
}

/* 图片上传样式 */
.bgcolor {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  font-size: 12px;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.5);
}
.img_hover_style {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  bottom: 0;
  display: flex;
}
.img_hover_style > div {
  display: none;
}
.img_hover_style:hover > div {
  display: block;
}

/* 多级联动 */
.level li:hover {
  background-color: #fdf8e9;
  color: #e9b722;
  cursor: pointer;
}
.level li.active {
  font-weight: 700;
  color: #e9b722;
  background-color: #fbf1d3;
}
.level li {
  padding-left: 5px;
}

.level::-webkit-scrollbar {
  display: none;
}

.level {
  position: absolute;
  left: 0px;
  top: 23px;
  height: 300px;
  overflow: auto;
  background-color: #fff;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
  z-index: 8;
}
.level1 {
  left: 0px;
  width: 144px;
  top: 23px;
}
.level2 {
  left: 50px;
  width: 144px;
  top: 23px;
}
.level3 {
  left: 100px;
  width: 144px;
  top: 23px;
}
.level4 {
  left: 150px;
  width: 144px;
  top: 23px;
}
.red {
  border-color: #d0021b !important;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 4px #d0021b;
}
.agreement .upload_img {
  background-image: none;
}
.img_style {
  background-size: contain !important;
}
.img_style_82 {
  background-size: 82px !important;
}
/*删除按钮*/
.icon.remove {
  width: 13px;
  height: 17px;
  background: url(~@/assets/img/account/icon_delete@2x.png) no-repeat center
    center;
  background-size: contain;
  vertical-align: -3px;
  display: inline-block;
}

.agreement .h23.ivu-select-single .ivu-select-selection {
  height: 23px;
  line-height: 23px;
  padding: 0;
  margin: 0;
}

.agreement .ivu-select .ivu-select-dropdown {
  width: 100%;
}

.agreement .h23 .ivu-select-input {
  height: 23px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/BankAgreementSanXiang.vue